import { Task, TaskProvider } from "../../types";
import { BarzhaResponse, BarzhaStatusTask } from "./types/barzha";

export class BarzhaAdapter {
  private static readonly BASE_URL = "https://app.barzha.com";

  static adaptTasks(
    barzhaResponse: BarzhaResponse,
    statusTasks: BarzhaStatusTask[]
  ): Task[] {
    console.log("🔄 BarzhaAdapter.adaptTasks - start", {
      barzhaResponse,
      statusTasks,
    });

    const { available_tasks, started_tasks } = barzhaResponse;
    const { status } = barzhaResponse;

    // Объединяем задания из available_tasks и started_tasks
    const allTasks =
      status === "error"
        ? []
        : [
            ...available_tasks,
            ...started_tasks.filter(
              (startedTask) =>
                !available_tasks.some(
                  (availableTask) =>
                    availableTask.ad_subscription_campaign_id ===
                    startedTask.ad_subscription_campaign_id
                )
            ),
          ];
    console.log(allTasks);
    return allTasks
      .map((task) => {
        // Проверяем, есть ли необходимые поля
        if (
          !("title" in task) ||
          !("description" in task) ||
          !("image_href" in task)
        ) {
          console.warn("Skipping task due to missing required fields:", task);
          return null;
        }

        // Ищем задание в статусах
        const statusTask = statusTasks.find(
          (st) => st.task_id === String(task.ad_subscription_campaign_id)
        );

        // Определяем visibility
        const visibility = statusTask ? statusTask.visibility : true;

        // Проверяем условия для отображения задания
        if (statusTask && statusTask.type === "task" && !visibility) {
          return null; // Не отображаем задание, если тип 'task' и visibility false
        }

        // Определяем статус
        // let status: Task['status'] = 'NOT_STARTED';

        // Определяем текст кнопки в зависимости от статуса

        return {
          id: task.ad_subscription_campaign_id,
          title: task.title as string,
          description: task.description as string,
          icon: `${this.BASE_URL}${task.image_href as string}`,
          type: "sponsors",
          rewards: {
            dc: 50,
            tickets: 1,
          },
          status: statusTask ? statusTask.status : "NOT_STARTED",
          buttonText: "Подписаться",
          url: "",
          progress: {
            current: 0,
            total: 1,
          },
          provider: "BARZHA" as TaskProvider,
          visibility: statusTask ? statusTask.visibility : true,
        } as Task;
      })
      .filter((task): task is Task => task !== null);
  }
}
